import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as dms from '../../dms'
import * as me from '../../me'

import { getActionsConfig } from './actions'
import * as dynamicEc from './ec'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Feature is responsible to manage dynamically created Entity Collections
 */
@ngCore.Injectable()
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Ec.Widgets',
      selectors: () => new Selectors(this),
    })

    const ecInjectables = ngCore.inject(ec.InjectableDependencies)
    const schemaFeature = ngCore.inject(dms.schema.Feature)
    const meFeature = ngCore.inject(me.Feature)

    this.registerEffects(
      effects.onBootstrap(meFeature, schemaFeature, ecInjectables),
      effects.onDispose(),
    )
  }

  /**
   * Destroys dynamic Mosaic entity collections before this registry feature is
   * removed from NgRx.
   */
  public override destroy(source: string): void {
    if (!this.lifecycle.isDestroyed) {
      // Dynamic widget collections are created at runtime, so they are not
      // directly owned by Angular's route injector provider list.
      const instances = ec.Collection.instances.find<dynamicEc.Name>({
        isName: dynamicEc.Name.isName,
      }).collections

      // Destroy them while this feature is still alive so each collection can
      // dispatch its normal feature/plugin teardown actions.
      for (const collection of instances) {
        collection.destroy(source)
      }
    }

    super.destroy(source)
  }
}
